import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { ForFundingDetailResult } from '../../../features/linking-for-funding/models/for-funding-detail-result.interface'
import {
   ForFundingCommentEntity,
   ForFundingContactResponsibleRequest,
   ForFundingPartnerEntity,
   ForFundingResponsibleEntity,
   ForFundingResult,
} from '../../../features/linking-for-funding/models/for-funding-result.interface'
import { ForFundingSearchFields } from '../../../features/linking-for-funding/models/for-funding-search-fields.interface'
import { ForFundingSoughtPartnerItem } from '../../../features/linking-for-funding/models/for-funding-sought-partner.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'
import { BasicSearchFields } from '../../models/interfaces/basic-search-fields.interface'

export const openForFundingSearch = createAction('[f-linking-tool] Open Linking for funding search')

export const closeForFundingSearch = createAction('[f-linking-tool] Close Linking for funding search')

export const toggleForFundingSearch = createAction('[f-linking-tool] Toggle Linking for funding search')

export const searchForFundingData = createAction('[f-linking-tool] Linking for funding SEARCHING data', props<{ searchFields: ForFundingSearchFields }>())

export const searchForFundingDataSuccess = createAction(
   '[f-linking-tool] Linking for funding SEARCHING data SUCCESS',
   props<{ data: BasicResult<BasicSearchFields, ForFundingResult> }>()
)

export const searchForFundingDataFailure = createAction('[f-linking-tool] Linking for funding SEARCHING data FAILURE', props<{ error: HttpErrorResponse }>())

export const downloadForFundingData = createAction('[f-linking-tool] Linking for funding DOWNLOADING data', props<{ searchFields?: ForFundingSearchFields }>())

export const downloadForFundingDataSuccess = createAction('[f-linking-tool] Linking for funding DOWNLOADING data SUCCESS')

export const downloadForFundingDataFailure = createAction(
   '[f-linking-tool] Linking for funding DOWNLOADING data FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const addForFundingComment = createAction(
   '[f-linking-tool] Linking for funding - adding comment',
   props<{ request: Partial<ForFundingCommentEntity> }>()
)

export const addForFundingCommentSuccess = createAction('[f-linking-tool] Linking for funding - adding comment SUCCESS')

export const addForFundingCommentFailure = createAction('[f-linking-tool] Linking for funding - adding comment FAILURE', props<{ error: HttpErrorResponse }>())

export const deleteForFundingComment = createAction(
   '[f-linking-tool] Linking for funding - deleting comment',
   props<{ request: Partial<ForFundingCommentEntity> }>()
)

export const deleteForFundingCommentSuccess = createAction('[f-linking-tool] Linking for funding - deleting comment SUCCESS')

export const deleteForFundingCommentFailure = createAction(
   '[f-linking-tool] Linking for funding - deleting comment FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const addForFundingCoordinator = createAction(
   '[f-linking-tool] Linking for funding - adding potential coordinator',
   props<{ request: Partial<ForFundingPartnerEntity> }>()
)

export const addForFundingCoordinatorSuccess = createAction(
   '[f-linking-tool] Linking for funding - adding potential coordinator SUCCESS',
   props<{ res: ForFundingPartnerEntity }>()
)

export const addForFundingCoordinatorFailure = createAction(
   '[f-linking-tool] Linking for funding - adding potential coordinator FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const editForFundingCoordinator = createAction(
   '[f-linking-tool] Linking for funding - editing potential coordinator',
   props<{ request: Partial<ForFundingPartnerEntity> }>()
)

export const editForFundingCoordinatorSuccess = createAction(
   '[f-linking-tool] Linking for funding - editing potential coordinator SUCCESS',
   props<{ res: ForFundingPartnerEntity }>()
)

export const editForFundingCoordinatorFailure = createAction(
   '[f-linking-tool] Linking for funding - editing potential coordinator FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const deleteForFundingCoordinator = createAction(
   '[f-linking-tool] Linking for funding - deleting potential coordinator',
   props<{ request: Partial<ForFundingPartnerEntity> }>()
)

export const deleteForFundingCoordinatorSuccess = createAction('[f-linking-tool] Linking for funding - deleting potential coordinator SUCCESS')

export const deleteForFundingCoordinatorFailure = createAction(
   '[f-linking-tool] Linking for funding - deleting potential coordinator FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const addForFundingPartner = createAction(
   '[f-linking-tool] Linking for funding - adding partner',
   props<{ request: Partial<ForFundingPartnerEntity> }>()
)

export const addForFundingPartnerSuccess = createAction(
   '[f-linking-tool] Linking for funding - adding partner SUCCESS',
   props<{ res: ForFundingPartnerEntity }>()
)

export const addForFundingPartnerFailure = createAction('[f-linking-tool] Linking for funding - adding partner FAILURE', props<{ error: HttpErrorResponse }>())

export const editForFundingPartner = createAction(
   '[f-linking-tool] Linking for funding - editing partner',
   props<{ request: Partial<ForFundingPartnerEntity> }>()
)

export const editForFundingPartnerSuccess = createAction(
   '[f-linking-tool] Linking for funding - editing partner SUCCESS',
   props<{ res: ForFundingPartnerEntity }>()
)

export const editForFundingPartnerFailure = createAction(
   '[f-linking-tool] Linking for funding - editing partner FAILURE',
   props<{ error: HttpErrorResponse }>()
)
export const deleteForFundingPartner = createAction(
   '[f-linking-tool] Linking for funding - deleting partner entity',
   props<{ request: Partial<ForFundingPartnerEntity> }>()
)

export const deleteForFundingPartnerSuccess = createAction('[f-linking-tool] Linking for funding - deleting partner SUCCESS')

export const deleteForFundingPartnerFailure = createAction(
   '[f-linking-tool] Linking for funding - deleting partner FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const addForFundingResponsible = createAction(
   '[f-linking-tool] Linking for funding - adding responsible',
   props<{ request: Partial<ForFundingResponsibleEntity> }>()
)

export const addForFundingResponsibleSuccess = createAction('[f-linking-tool] Linking for funding - adding responsible SUCCESS')

export const addForFundingResponsibleFailure = createAction(
   '[f-linking-tool] Linking for funding - adding responsible FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const addForFundingPNOResponsible = createAction('[f-linking-tool] Linking for funding - adding PNO responsible', props<{ matchmakingId: string }>())

export const addForFundingPNOResponsibleSuccess = createAction('[f-linking-tool] Linking for funding - adding PNO responsible SUCCESS')

export const addForFundingPNOResponsibleFailure = createAction(
   '[f-linking-tool] Linking for funding - adding PNO responsible FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const deleteForFundingResponsible = createAction(
   '[f-linking-tool] Linking for funding - deleting responsible entity',
   props<{ request: { id: number } }>()
)

export const deleteForFundingResponsibleSuccess = createAction('[f-linking-tool] Linking for funding - deleting responsible SUCCESS')

export const deleteForFundingResponsibleFailure = createAction(
   '[f-linking-tool] Linking for funding - deleting responsible FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const contactForFundingResponsible = createAction(
   '[f-linking-tool] Linking for funding - contacting responsible',
   props<{ grantId: number; request: ForFundingContactResponsibleRequest }>()
)

export const contactForFundingResponsibleSuccess = createAction('[f-linking-tool] Linking for funding - contacting responsible SUCCESS')

export const contactForFundingResponsibleFailure = createAction(
   '[f-linking-tool] Linking for funding - contacting responsible FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const resetForFundingState = createAction('[f-linking-tool] Linking for funding  - RESET DATA')

export const setForFundingSearchFields = createAction(
   '[f-linking-tool] Linking for funding - SETTING search fields',
   props<{ searchFields: ForFundingSearchFields }>()
)

export const getFundingDataByID = createAction('[f-linking-tool] Linking for funding - GETTING data by ID', props<{ id: number }>())

export const getFundingDataByIDSuccess = createAction(
   '[f-linking-tool] Linking for funding - GETTING data by ID SUCCESS',
   props<{ data: ForFundingDetailResult }>()
)

export const getFundingDataByIDFailure = createAction(
   '[f-linking-tool] Linking for funding - GETTING data by ID FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const setItemIdToScroll = createAction(
   '[f-linking-tool] Linking for funding - SETTING item ID to scroll',
   props<{ id?: number; isPartnerToScroll?: boolean; isCoordinatorToScroll?: boolean; isCommentsToScroll?: boolean }>()
)

// seeking partners
export const addSoughtPartner = createAction(
   '[f-linking-tool] Linking for funding - adding sought partner to table',
   props<{ body: ForFundingSoughtPartnerItem }>()
)

export const replaceSoughtPartner = createAction(
   '[f-linking-tool] Linking for funding - replacing sought partner in table',
   props<{ index: number; body: ForFundingSoughtPartnerItem }>()
)

export const removeSoughtPartner = createAction('[f-linking-tool] Linking for funding - removing sought partner from table', props<{ index: number }>())

export const getSoughtPartners = createAction('[f-linking-tool] Linking for funding - getting sought partners', props<{ matchmakingId: number }>())

export const getSoughtPartnersSuccess = createAction(
   '[f-linking-tool] Linking for funding - getting sought partners SUCCESS',
   props<{ data: ForFundingSoughtPartnerItem[] }>()
)

export const getSoughtPartnersFailure = createAction(
   '[f-linking-tool] Linking for funding - getting sought partners FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const saveSoughtPartnerAndSendNotification = createAction(
   '[f-linking-tool] Linking for funding - saving sought partner and sending notification',
   props<{ matchmakingId: number; data: ForFundingSoughtPartnerItem[] }>()
)

export const saveSoughtPartnerAndSendNotificationSuccess = createAction(
   '[f-linking-tool] Linking for funding - saving sought partner and sending notification SUCCESS'
)

export const saveSoughtPartnerAndSendNotificationFailure = createAction(
   '[f-linking-tool] Linking for funding - saving sought partner and sending notification FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const sendJustNotificationForSoughtPartner = createAction(
   '[f-linking-tool] Linking for funding - sending just notification for sought partner',
   props<{ matchmakingId: number }>()
)

export const sendJustNotificationForSoughtPartnerSuccess = createAction(
   '[f-linking-tool] Linking for funding - sending just notification for sought partner SUCCESS'
)

export const sendJustNotificationForSoughtPartnerFailure = createAction(
   '[f-linking-tool] Linking for funding - sending just notification for sought partner FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const cleanSoughtPartnersData = createAction('[f-linking-tool] Linking for funding - CLEANING sought partners data')
